import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { MULTI_CART_FEATURE, MultiCartService, StateWithMultiCart } from '@spartacus/cart/base/core';
import { ActiveCartFacade, DeleteCartSuccessEvent } from '@spartacus/cart/base/root';
import { AuthService, EventService, GlobalMessageService, GlobalMessageType, UserIdService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { filter, map, mergeMap, pairwise, take } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
@Component({
  selector: 'app-delete-cart-modal',
  templateUrl: './delete-cart-modal.component.html',
  styleUrls: ['./delete-cart-modal.component.scss'],
  standalone: false,
})
export class DeleteCartModalComponent implements OnInit, OnDestroy {
  cartId: string;
  userCurrent$: Observable<string> = this.userIdService.getUserId();
  cart: any;
  deleteAllButtonClicked: boolean;
  activeCartServiceSubscription$: Subscription;
  deleteCartSuccessSubscription$: Subscription;

  constructor(
    protected modalService: StandardModalService,
    private multiCartService: MultiCartService,
    private activeCartService: ActiveCartFacade,
    private messageService: GlobalMessageService,
    protected auth: AuthService,
    private store: Store<StateWithMultiCart>,
    private componentService: ComponentService,
    private userIdService: UserIdService,
    private eventService: EventService,
    private languageService: ShimanoLanguageService
  ) {
    this.modalService
      .getModalData()
      .pipe(take(1))
      .subscribe((res) => (this.cartId = res.cartId));
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }
  ngOnInit() {
    this.multiCartService
      .getEntries(this.cartId)
      .pipe(take(1))
      .subscribe((entries) => {
        this.componentService.cartEntries$.next(entries);
      });
    this.watchDeleteCartSuccessEvent();
  }

  deleteAllCart(): void {
    // add flag to avoid multiple request
    if (!this.deleteAllButtonClicked) {
      this.multiCartService.deleteCart(this.cartId, this.userCurrent);
      this.cart = this.store.pipe(select(MULTI_CART_FEATURE));
      this.deleteAllButtonClicked = true;
      this.activeCartServiceSubscription$ = this.getNewCart().subscribe((newCart) => {
        if (newCart && newCart.active === '' && newCart.carts.entities.constructor === Object) {
          this.multiCartService
            .createCart({
              userId: this.userCurrent,
              extraData: {
                active: true,
              },
            })
            .pipe(take(1))
            .subscribe();
        }
      });
    }
  }

  getNewCart(): Observable<any> {
    // get cart when cart is not loading/stable
    return this.activeCartService.getLoading().pipe(
      filter((cartLoading: boolean) => !cartLoading),
      mergeMap((loading: boolean) => {
        return this.cart.pipe(take(1));
      }),
      pairwise(),
      map(([prevCart, currentCart]: any) => {
        if (prevCart.active !== currentCart.active) {
          return currentCart;
        }
      })
    );
  }

  watchDeleteCartSuccessEvent(): void {
    this.deleteCartSuccessSubscription$ = this.eventService
      .get(DeleteCartSuccessEvent)
      .subscribe(() => this.deleteCartSuccess());
  }

  deleteCartSuccess(): void {
    this.deleteAllButtonClicked = false;
    this.closeModal('deleted cart');
    this.showGlobalMessage('cart.deleteAllModal.deleteSuccess', null, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    this.componentService.onDeleteCart$.next(true);
    this.activeCartServiceSubscription$?.unsubscribe();
  }

  closeModal(info?: any) {
    this.modalService.closeDialog(info);
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  private showGlobalMessage(text: string, param: string, messageType: GlobalMessageType) {
    this.messageService.add({ key: text, params: { productName: param } }, messageType);
    const element: HTMLElement = document.getElementsByClassName('BottomHeaderSlot')[0] as HTMLElement;
    element.scrollIntoView();
  }

  ngOnDestroy(): void {
    this.activeCartServiceSubscription$?.unsubscribe();
    this.deleteCartSuccessSubscription$?.unsubscribe();
  }
}
